import API from "./api"

const UserService = {
  // Get all users (admin only)
  getUsers: async () => {
    try {
      const response = await API.get("/users")
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Get a single user by ID
  getUserById: async (id) => {
    try {
      const response = await API.get(`/users/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Get current user profile
  getCurrentUser: async () => {
    try {
      const response = await API.get("/users/profile")
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Create a new user (admin only)
  createUser: async (userData) => {
    try {
      const response = await API.post("/users", userData)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Update an existing user
  updateUser: async (id, userData) => {
    try {
      const response = await API.put(`/users/${id}`, userData)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Delete a user (admin only)
  deleteUser: async (id) => {
    try {
      const response = await API.delete(`/users/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  },
  
  // Register a new user (public)
  register: async (userData) => {
    try {
      const response = await API.post("/users/register", userData)
      return response.data
    } catch (error) {
      console.log('Inside catch in userService ', error); 
      throw error
    }
  },

  // Login admin
  adminLogin: async (email, password) => {
    try {
      console.log('Inside Admin Login');
      const response = await API.post("/users/admin/login", { email, password })
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Login user
  login: async (email, password) => {
    try{
      const response = await API.post("users/login", {email, password});
      return response.data;
    }catch(error) {
      throw error 
    }
  },

  // Update user profile
  updateProfile: async (userData) => {
    try {
      const response = await API.put("/users/profile", userData)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Upload user avatar
  uploadAvatar: async (imageFile) => {
    try {
      const formData = new FormData()
      formData.append("avatar", imageFile)

      const response = await API.post("/upload/avatar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      return response.data
    } catch (error) {
      throw error
    }
  },
}

export default UserService

